import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index';
import Vue2Filters from 'vue2-filters';
import VueLodash from 'vue-lodash';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
var VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false;

// Vue plugins
Vue.use(Vue2Filters);
Vue.use(VueLodash);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueScrollTo, {
   container: "#landing",
   duration: 2600,
   easing: "ease",
   offset: -60,
   force: true,
   cancelable: true,
   onStart: false,
   onDone: false,
   onCancel: false,
   x: false,
   y: true
});

// * Load Components *

/* eslint-disable no-new */
new Vue({
   el: '#app',
   router,
   store,
   render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js